import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Button/Button'; // Adjust path as needed
import logo from '../../../image-assets/logo.svg'; // Adjust path as needed
import './LandingNav.css';

const LandingNav = () => {

  // Updated scroll handler to use scrollIntoView
  const handleScrollTo = (event: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    event.preventDefault(); // Prevent default anchor jump
    
    // Remove '#' from targetId for getElementById
    const id = targetId.substring(1);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      targetElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' // Match hero button scroll block 
      });
    }
  };

  // Function to scroll to top (used by button, so no preventDefault needed)
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="landing-nav">
      {/* Wrap logo in link for scroll-to-top */}
      <button type="button" onClick={handleScrollToTop} className="landing-nav-logo-link">
        <img src={logo} alt="Texta Logo" className="landing-nav-logo" />
      </button>

      {/* Updated Middle Nav Links */}
      <div className="landing-nav-links">
        <a href="#writers" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#writers')}>
          <Button variant="text" size="medium">Write</Button>
        </a>
        <a href="#localization" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#localization')}>
          <Button variant="text" size="medium">Translate</Button>
        </a>
        <a href="#developers" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#developers')}>
          <Button variant="text" size="medium">Build</Button>
        </a>
        <a href="#teams" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#teams')}>
          <Button variant="text" size="medium">Collaborate</Button>
        </a>
        <a href="#pricing" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#pricing')}>
          <Button variant="text" size="medium">Pricing</Button>
        </a>
        <a href="#faq" className="landing-nav-link" onClick={(e) => handleScrollTo(e, '#faq')}>
          <Button variant="text" size="medium">FAQ</Button>
        </a>
      </div>

      {/* Auth Buttons */}
      <div className="landing-nav-auth">
        <Link to="/login" className="landing-nav-link landing-nav-login-link">
          <Button variant="text" size="medium">Log In</Button>
        </Link>
        <Link to="/signup" className="landing-nav-link">
          <Button variant="primary" size="medium">Sign Up</Button>
        </Link>
      </div>
    </nav>
  );
};

export default LandingNav; 